/**
 * Opens and closes size guide dialogs for the variant picker block.
 */
function initSizeGuide() {
  document.querySelectorAll('[data-size-guide-open]').forEach((trigger) => {
    if (trigger.dataset.sizeGuideBound === 'true') return;

    trigger.dataset.sizeGuideBound = 'true';
    trigger.addEventListener('click', () => {
      const dialogId = trigger.getAttribute('aria-controls');
      const dialog = dialogId ? document.getElementById(dialogId) : null;

      if (dialog instanceof HTMLDialogElement) {
        dialog.showModal();
      }
    });
  });

  document.querySelectorAll('[data-size-guide-close]').forEach((closeButton) => {
    if (closeButton.dataset.sizeGuideBound === 'true') return;

    closeButton.dataset.sizeGuideBound = 'true';
    closeButton.addEventListener('click', () => {
      closeButton.closest('dialog')?.close();
    });
  });

  document.querySelectorAll('dialog.size-guide-modal').forEach((dialog) => {
    if (dialog.dataset.sizeGuideBound === 'true') return;

    dialog.dataset.sizeGuideBound = 'true';
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) {
        dialog.close();
      }
    });
  });
}

initSizeGuide();

document.addEventListener('shopify:section:load', initSizeGuide);
document.addEventListener('shopify:block:select', initSizeGuide);